import { render, staticRenderFns } from "./DynameatManagementButton.vue?vue&type=template&id=2b1be0a0&scoped=true&"
import script from "./DynameatManagementButton.vue?vue&type=script&lang=js&"
export * from "./DynameatManagementButton.vue?vue&type=script&lang=js&"
import style0 from "./DynameatManagementButton.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DynameatManagementButton.vue?vue&type=style&index=1&id=2b1be0a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1be0a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VCard,VCardText,VFlex,VIcon})
